/** @format */

import React from "react"
import { Container, StyledNoSearchResultIconSvg } from "./NoContractsFound.styled"

export const NoContractsFound = () => {
  
    return (
        <Container>
            <StyledNoSearchResultIconSvg/>
            <h1 data-testid="no-contracts-found">
                Aucun contrat trouvé.
            </h1>
            <span>Merci de contacter votre service support</span>
        </Container>
	)
}

